/** NAICS 2-digit sector labels. Source: Census NAICS sector structure. */
export const NAICS_SECTORS: Record<string, string> = {
  '11': 'Agriculture, Forestry, Fishing and Hunting',
  '21': 'Mining, Quarrying, and Oil and Gas Extraction',
  '22': 'Utilities',
  '23': 'Construction',
  '31': 'Manufacturing',
  '32': 'Manufacturing',
  '33': 'Manufacturing',
  '42': 'Wholesale Trade',
  '44': 'Retail Trade',
  '45': 'Retail Trade',
  '48': 'Transportation and Warehousing',
  '49': 'Transportation and Warehousing',
  '51': 'Information',
  '52': 'Finance and Insurance',
  '53': 'Real Estate and Rental and Leasing',
  '54': 'Professional, Scientific, and Technical Services',
  '55': 'Management of Companies and Enterprises',
  '56': 'Administrative, Support and Waste Management',
  '61': 'Educational Services',
  '62': 'Health Care and Social Assistance',
  '71': 'Arts, Entertainment, and Recreation',
  '72': 'Accommodation and Food Services',
  '81': 'Other Services (except Public Administration)',
  '92': 'Public Administration',
};

/** First two digits of a NAICS code, or null if unusable. */
export function naics2(code: string): string | null {
  const digits = String(code).replace(/\D/g, '');
  if (digits.length < 2) return null;
  const two = digits.slice(0, 2);
  return two in NAICS_SECTORS ? two : null;
}

export function sectorLabel(code: string): string {
  const two = naics2(code);
  return two ? (NAICS_SECTORS[two] ?? 'Unknown industry') : 'Unknown industry';
}
